<template>
    <div :class="classes" @click="handleClick"></div>
</template>
<script>
    import theme from './radioRaw.scss';

    export default {
        name: 'radio-raw',
        props: {
            value: [String, Number, Boolean, Object],
            data: [String, Number, Boolean, Object],
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                theme,
            };
        },
        computed: {
            classes() {
                return {
                    [theme.radioControl]: true,
                    [theme.isChecked]: this.data === this.value,
                    [theme.isDisabled]: this.disabled,
                }
            }
        },
        methods: {
            handleClick() {
                this.$emit('input', this.data);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// RadioRaw.vue?e3ace9ea